package one.healthium.paywall.di

import one.healthium.notifications.di.notificationsModule
import one.healthium.paywall.ui.PaywallViewModel
import one.healthium.paywall.ui.scheduler.RemarketingManager
import one.healthium.url_provider.di.urlProviderModule
import org.koin.core.module.dsl.factoryOf
import org.koin.core.module.dsl.viewModelOf
import org.koin.dsl.module

val paywallModule = module {
    includes(paywallPlatformModule(), urlProviderModule, notificationsModule)
    factoryOf(::RemarketingManager)
    viewModelOf(::PaywallViewModel)
}